import { InjectionToken } from '@angular/core';
import * as i0 from "@angular/core";
export var APP_CONFIG = new InjectionToken('app.config');
var ConfigService = /** @class */ (function () {
    function ConfigService() {
        this.config = null;
    }
    ConfigService.prototype.setConfig = function (config) {
        this.config = config;
    };
    ConfigService.prototype.get = function (key) {
        if (!this.config) {
            throw new Error('Configuration not loaded. Make sure APP_INITIALIZER is configured properly.');
        }
        return this.config[key];
    };
    ConfigService.prototype.getAll = function () {
        if (!this.config) {
            throw new Error('Configuration not loaded. Make sure APP_INITIALIZER is configured properly.');
        }
        return this.config;
    };
    ConfigService.prototype.isLoaded = function () {
        return this.config !== null;
    };
    ConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(); }, token: ConfigService, providedIn: "root" });
    return ConfigService;
}());
export { ConfigService };
